import { ODataOptions } from '../util/ODataBuilder';
import BaseApi from './BaseApi';

import ClientModel from '../models/Client';
import { IAppContextState } from 'src/reducers/AppContext';
import { UrlFactory } from './urlHelper';

export interface IClient {
    getAll(options: ODataOptions, jwt: string): Promise<object>;
    get(clientNumber: number, jwt: string): Promise<object>;
    create(client: ClientModel, jwt: string): Promise<object>;
    addFavorite(clientNumber: number, jwt: string): Promise<object>;
    removeFavorite(clientNumber: number, jwt: string): Promise<object>;
    update(client: ClientModel, jwt: string): Promise<object>;
    delete(clientNumber: number, jwt: string): Promise<object>;
}

export default class Client extends BaseApi implements IClient {
    constructor(baseUrl: string) {
        super(baseUrl);

        this.getAll = this.getAll.bind(this);
        this.get = this.get.bind(this);
        this.create = this.create.bind(this);
        this.addFavorite = this.addFavorite.bind(this);
        this.removeFavorite = this.removeFavorite.bind(this);
        this.update = this.update.bind(this);
        this.delete = this.delete.bind(this);
    }

    public getAll(options: ODataOptions, jwt: string): Promise<object> {
        const filter = options
            .getFilters()
            .map((item) => item.toString())
            .join('--and--');
        const query = filter ? options.toString().replace(`$filter=${filter}`, `$filter=${encodeURIComponent(filter)}`) : options.toString();
        return this.getRequest(`${this.baseUrl}v1.0/clients${query}`, jwt);
    }

    public get(clientNumber: number, jwt: string) {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}`, jwt);
    }

    public create(client: ClientModel, jwt: string) {
        return this.postRequest(`${this.baseUrl}v1.0/clients`, client, jwt);
    }

    public addFavorite(clientNumber: number, jwt: string) {
        return this.putRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/favorite`, undefined, jwt);
    }

    public removeFavorite(clientNumber: number, jwt: string) {
        return this.deleteRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/favorite`, undefined, jwt);
    }

    public update(client: ClientModel, jwt: string) {
        return this.putRequest(`${this.baseUrl}v1.0/clients/${client.clientNumber}`, client, jwt);
    }

    public delete(clientNumber: number, jwt: string) {
        return this.deleteRequest(`${this.baseUrl}v1.0/clients/${clientNumber}`, undefined, jwt);
    }
}

export const ClientUrl = {
    clients: () => `${UrlFactory.RootApi}clients`,
    client: (appContext: IAppContextState, clientNumber: number) => `${UrlFactory.RootApi}clients/${clientNumber}`,
};



// WEBPACK FOOTER //
// ./src/api/Client.ts